/**
 * Uploads a file straight to S3 via a presigned POST instead of sending the bytes
 * through our own API — API Gateway has a hard 10MB request payload ceiling
 * (non-negotiable, can't be raised), and a batch of question media can easily
 * exceed that even when each individual file is small. A presigned POST (rather
 * than a presigned PUT) lets S3 itself enforce the server's maxBytes via a
 * content-length-range condition, so an oversized upload is rejected by S3 even
 * if this client-side check is bypassed. Returns the S3 key to save in the record.
 * Same flow as themeupdate.jsx's inline uploadFileDirectToS3, extracted here so
 * the Stage Quiz admin page can reuse it too.
 */
export async function uploadFileDirectToS3({
  adminToken,
  organizationId,
  sessionId,
  currentTheme,
  kind,
  file,
}) {
  const urlRes = await fetch(`${process.env.REACT_APP_BACKEND_URL}/getUploadUrl`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${adminToken}` },
    body: JSON.stringify({ organizationId, sessionId, currentTheme, kind, fileName: file.name }),
  });
  const urlData = await urlRes.json();
  if (!urlData.success) throw new Error(urlData.message || "Failed to prepare upload");
  if (!urlData.fields || typeof urlData.fields !== "object" || !urlData.uploadUrl) {
    throw new Error("Upload could not be prepared. Please try again.");
  }

  const formData = new FormData();
  Object.entries(urlData.fields).forEach(([key, value]) => formData.append(key, value));
  formData.append("file", file);

  const postRes = await fetch(urlData.uploadUrl, {
    method: "POST",
    body: formData,
  });
  if (!postRes.ok) throw new Error("Failed to upload file to storage");

  return urlData.key;
}
